module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp3_6005.51791751.png";